import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import img from "../../../assets/images/landing/team.jpg";
import { useTranslation } from 'react-i18next';

const Connect = () => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <section className="section" id="wallet">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={6}>
                            <div className="text-center mb-5">
                                <img src={img} alt="" className="img-fluid" />
                            </div>
                        </Col>
                        <Col lg={6} className='ps-1 ps-5'>
                            <div className="text-start mb-5">
                                <h2 className="mb-3 fw-semibold lh-base">
                                    {t("connect.title")}
                                </h2>
                                <p className="text-muted">
                                    {t("connect.subtitle")}
                                </p>
                                <div className="vstack gap-2">
                                    {[1, 2, 3, 4].map(i => (
                                        <div className="d-flex align-items-start" key={i}>
                                            <div className="flex-shrink-0 me-2">
                                                <div className="avatar-xs icon-effect">
                                                    <div className="avatar-title bg-transparent text-success rounded-circle h2">
                                                        <i className="ri-check-fill"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex-grow-1">
                                                <p className="mb-0">{t(`connect.item${i}`)}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
}

export default Connect;
